export default __webpack_public_path__ + "static/media/Henderson Claims - Privacy Policy - June 2024.6bf93601.b044989a.pdf";